import styled from '@emotion/styled';

import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import { GettingStartedData, GettingStartedMobileData } from './GettingStartedData';
import ComponentHeader from '../../../components/ComponentHeader/ComponentHeader';
import Slider from "react-slick";

const GettingStarted = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.1,
  });

  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    showArrows: false
  };

  return (
    <Container className='intersection-animate'>
      <ComponentHeader text="Getting Started" />
      <Space></Space>
      <WebWrapper>
        <Slider {...settings}>
          {GettingStartedData.map((data, index) => (
            <ImageWrapper
              key={index}
            >
              <Img src={data.imageName} alt={`slider ${index + 1}`} />
            </ImageWrapper>
          ))}
        </Slider>
      </WebWrapper>
      <MobileWrapper>
        <Slider {...settings}>
          {GettingStartedMobileData.map((data, index) => (
            <ImageWrapper
              key={index}
            >
              <Img src={data.imageName} alt={`slider ${index + 1}`} />
            </ImageWrapper>
          ))}
        </Slider>
      </MobileWrapper>
    </Container>
  );
};

export default GettingStarted;

const Container = styled.div`
  padding-bottom: 100px;
  // display: flex;
  // flex-direction: column;
  // align-items:center;
  // justify-content: center;
  gap: 40px;


  @media (max-width: 884px) {
    align-items: center;
    padding-bottom: 55px;
  }

  & .slick-dots > li.slick-active > button::before {
        color: ${({ theme }) => theme.palette.redFontColor} !important; 
    }
`;

const Space = styled.div`
  padding: 1rem;
`;

const WebWrapper = styled.div`
  display: none;

  @media (min-width: 884px) {
    display: block;
  }
`;

const MobileWrapper = styled.div`
  display: block;

  @media (min-width: 884px) {
    display: none;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 90vw;
  display: grid;
  place-items: center;
  border-radius: 12px;
  overflow: hidden;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 12px;
`;


